/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/*globals Tc */

/*
	Tc.Module.RetentionDisplay.js is deprecated.
	See Tc.Module.RetentionResult.ts
	*/

// Use a 10x longer timeout than what is globally set (30000).
// because the e-commerce backend can take a very long time to respond
var AJAX_TIMEOUT = 300000;
var STATE = {
	green: 'green',
	loggedOut: 'loggedOut',
	noRetentionPossible: 'noretentionpossible',
	futureRetentionPossible: 'futureretentionpossible',
	retentionPossible: 'retentionpossible',
	loading: 'loading',
	cbuInSmeOrRes: 'cbuinsmeorres',
	error: 'error'
};
var ERROR = {
	DATA: 'data',
	TIMEOUT: 'timeout'
};
var HASH_SUFFIX = 'retention';

/**
 * @namespace Tc.Module
 * @class RetentionDisplay
 * @extends Tc.Module
 */
Tc.Module.RetentionDisplay = Tc.Module.extend({

	on: function (callback) {
		var mod = this;

		mod.pageSegment = $('body').data('page-segment');
		// cache data object, because data access is slow. jquery removes dashes in this process and stores
		// properties in camel case: some-attribute-name becomes someAttributeName
		mod.data = mod.$ctx.data();
		mod.productId = mod.data.productId;
		mod.hasProductDataHub = !!$('.modEcommerceProductDataHub').length;
		mod.hideActionButton = mod.data.hideActionButton;

		mod.$message = mod.$ctx.find('.retention-message');
		mod.$buyButton = mod.$ctx.find('.retention-action-button');
		mod.$buyButtonLink = mod.$buyButton.find('a');
		mod.$buyButtonLink.on('click', $.proxy(mod.handleBuyButton, mod));
		mod.$loginButton = mod.$ctx.find('.retention-login-button');

		mod.contractsWithRetention = [];
		mod.contractsWithoutRetention = [];
		mod.currentUiState = {};

		// restyle the secondary button on the login button
		mod.$loginButton.find('a').addClass('primary-button').removeClass('secondary-button');

		// establish connection to Product Data Hub
		if (mod.hasProductDataHub) {
			mod.onStartProductDataSubscription();
		}

		callback();
	},

	after: function () {
		var mod = this;

		require('lib/personalization/profile').getProfile().then(function(profile) {
			mod.user = profile.getUser();
			if(mod.user) {
				// cbu customers can not use this feature. Hence, they are asked to redirect to go to the cbu shop.
				if (mod.user.getSegment() === 'cbu') {
					mod.showUiState(STATE.cbuInSmeOrRes);
				}
				else {
					if (window.location.hash.indexOf(HASH_SUFFIX) > -1) {
						if(!(mod.debug && document.location.hash.indexOf('disableUrlRewrite') > -1)) {
							SCS.Url.removeHashParameter(HASH_SUFFIX);
						}
						mod.loadContractsOverview();
					}
					else {
						mod.showUiState(STATE.loggedOut);
					}
				}
			} else {
				mod.showUiState(STATE.loggedOut);
			}

			if (mod.productDataChannel) {
				mod.fire('getInfo', {
					callback: function (data) {
						mod.updateOnProductData(data);
					}
				}, [mod.productDataChannel]);
				mod.fire('removeHashParameter', HASH_SUFFIX, [mod.productDataChannel]);
			}
		});
	},

	onRetentionButtonClick: function () {
		this.loadContractsOverview();
	},

	/**
	 * loadContractsOverview
	 * loads available contracts for a retention upgrade from the server
	 * Response (Array of Strings containing ALL phone numbers listed under this account, not only the :
	 * [
	 *        '+41791039311',
	 *        '+41791039315'
	 *    ]
	 */
	loadContractsOverview: function () {
		var mod = this;
		mod.showUiState(STATE.loading);
		mod.contractsWithRetention = [];
		mod.contractsWithoutRetention = [];

		// use debug data if debug mode is on.
		$.ajax({
			timeout: AJAX_TIMEOUT,
			url: SCS.portal.addParamToUrl(mod.data.urlLoadContracts, 'id', mod.user.getId()),
			success: function (contracts) {
				if ($.isArray(contracts)) {
					if (contracts.length) {
						mod.loadContractDetails(contracts, 0);
					}
					else {
						mod.showUiState(STATE.noRetentionPossible);
					}
				}
				else {
					mod.showError();
				}
			},
			error: function (xhr, textStatus, errorThrown) {
				mod.showError(errorThrown, xhr);
			}
		});
	},


	/**
	 * Loading the details of a single contract
	 * url: /portalshop/de/res/Retention/GetRetentionContractDetails?subscriptionNumber={{NUMBER}}
	 *
	 * response:
	 * {
			 *      RetentionContractDetailsModel: {
			 *          ContractEndDate: '/Date(1423263600000+0100)/',
			 *          ContractType: 1,
			 *          DaysUntilOffer: 0,
			 *          ExistingAboName: 'NATEL® infinity L',
			 *          MaximumAllowedDiscount: '100',
			 *          Options: null,
			 *          PremiumDiscount: '',
			 *          ReasonCode: 'R1.0',
			 *          ReasonText: 'Sie können jetzt von unserem Treueangebot profitieren und erhalten die aktuellsten Mobiltelefone zu Sonderkonditionen.',
			 *          Status: 'green',
			 *          SubscriptionNumber: '+41791231234',
			 *          SubscriptionNumberMD5Hash: 'CC77768E6D8756878898B18838A0B132'
			 *      }
			 * }
	 *
	 * Worth mentioning:
	 * ContractEndDate: The end date of the contract, can be used to display a Date, when a retention is possible.
	 * Status:    Red        = contract is not entitled for a retention offer
	 *            Green        = contract is entitled for a retention offer
	 *
	 * @param contracts        - Array with cell phone numbers registered under the current user
	 */
	loadContractDetails: function (contracts, index) {
		var mod = this,
			url = SCS.portal.addParamToUrl(mod.data.urlLoadContractDetails, 'subscriptionNumber', contracts[index]);

		mod.fire('loadContractDetails');

		$.ajax({
			timeout: AJAX_TIMEOUT,
			url: url,
			success: function (details) {
				var contractDetails;
				if (details && details.RetentionContractDetailsModel) {
					contractDetails = details.RetentionContractDetailsModel;
				}
				if (contractDetails && contractDetails.Status.indexOf('error') === -1) {
					if (contractDetails.Status.toLowerCase() === STATE.green) {
						mod.contractsWithRetention.push(contractDetails);
						mod.contractsLoadingHandler();
						return;
					}
					else {
						mod.contractsWithoutRetention.push(contractDetails);
					}
				}

				if ((index + 1) < (contracts.length)) {
					mod.loadContractDetails(contracts, (index + 1));
				}
				else {
					if (contractDetails && contractDetails.Status.indexOf('error') > -1) {
						mod.ajaxError = ERROR.TIMEOUT;
					}
					mod.contractsLoadingHandler();
				}
			},
			error: function (xhr, textStatus, errorThrown) {
				if ((index + 1) < (contracts.length)) {
					mod.loadContractDetails(contracts, (index + 1));
				}
				else {
					mod.showError(errorThrown, xhr);
				}
			}
		});
	},

	contractsLoadingHandler: function () {
		var mod = this;

		if (mod.ajaxError) {
			if (mod.ajaxError === ERROR.TIMEOUT) {
				mod.showError(ERROR.TIMEOUT);
			}
			else {
				mod.showError();
			}
		}
		else {
			mod.showRetentionResults();
		}
	},

	/**
	 * Prepare or show the results of the load contract details call(s).
	 */
	showRetentionResults: function () {
		var mod = this,
			doTrack = true,
			buyUrl,
			retentionStatus;

		if (mod.contractsWithRetention.length === 0) {
			if (mod.contractsWithoutRetention.length === 0) {
				$('.retention-message', mod.$ctx).addClass('noRetentionPossible');
				mod.showUiState(STATE.noRetentionPossible);
				retentionStatus = 'noRetentionPossible';
			}
			else {
				var nearestContract = mod.getContractWithNearestEndDate();
				if (nearestContract) {
					$('.retention-message', mod.$ctx).addClass('futureRetentionPossible');
					mod.showUiState(STATE.futureRetentionPossible, nearestContract);
					retentionStatus = 'futureRetentionPossible';
				}
				else {
					$('.retention-message', mod.$ctx).addClass('noRetentionPossible');
					mod.showUiState(STATE.noRetentionPossible);
					retentionStatus = 'noRetentionPossible';
				}
			}
		}
		else {
			$('.retention-message', mod.$ctx).addClass('retentionPossible');
			buyUrl = mod.getBuyUrl(mod.contractsWithRetention[0]); // just use the first possible contract for the deeplink
			if (buyUrl) {
				mod.showUiState(STATE.retentionPossible, mod.contractsWithRetention[0]);
				mod.setBuyButtonLink(buyUrl, mod.data.labelLinkOrder);
				retentionStatus = 'retentionPossible';
			}
			else {
				mod.currentUiState.state = STATE.error;
				mod.showError();
				doTrack = false;
				$('.retention-message', mod.$ctx).removeClass('retentionPossible');
				mod.log('no product configuration page set');
			}
		}
		if (doTrack) {
			// Fire tracking call
			var interaction = new SCS.portal.datalayer.Interaction()
				.withEvent('response', retentionStatus, 'productDetailPage', 'checker');
			mod.log('fire tracking call: ', interaction);
			interaction.track();
		}
	},

	/**
	 * Switch between different ui states.
	 *
	 * @param status Name of the state
	 */
	showUiState: function (uiState, contractData) {
		var mod = this;

		mod.currentUiState.state = uiState;
		mod.currentUiState.contractData = contractData;

		mod.$ctx.removeClass('loading-indicator');
		mod.$loginButton.addClass('hidden');
		mod.setBuyButtonLink();
		mod.showMessage();

		switch (uiState) {
			case STATE.loggedOut:
				mod.$loginButton.removeClass('hidden');
				break;
			case STATE.loading:
				mod.$ctx.addClass('loading-indicator');
				mod.showMessage(mod.data.messageLoading);
				break;
			case STATE.noRetentionPossible:
				mod.showMessage(mod.data.messageNoRetentionPossible);
				break;
			case STATE.futureRetentionPossible:
				var date = new Date(parseInt(mod.getTimeString(contractData.ContractEndDate), 10)),
					dateString = date.getDate() + '. ' + (date.getMonth() + 1) + '. ' + date.getFullYear();
				mod.showMessage(SCS.utils.formatString(mod.data.messageFutureRetentionPossible, dateString));
				break;
			case STATE.retentionPossible:
				mod.showMessage(mod.data.messageRetentionPossible);
				if(!mod.hideActionButton) {
					mod.$buyButton.removeClass('hidden');
				}
				break;
			case STATE.cbuInSmeOrRes:
				mod.showMessage(mod.data.messageCbuInResOrSme);
				mod.setBuyButtonLink(mod.data.urlCbu, mod.data.labelLinkToCbuShop);
				break;
			case STATE.error:
				mod.showMessage(mod.data.messageError);
				break;
			default:
				// simply do nothing
				break;
		}
	},

	showMessage: function (message) {
		if (message && message.length) {
			this.$message.html(message);
			this.$message.removeClass('hidden');
			$('html, body').animate({scrollTop: this.$message.offset().top - 100}, 'fast');
		}
		else {
			this.$message.html('');
			this.$message.addClass('hidden');
		}
	},

	setBuyButtonLink: function (link, label) {
		if (link && link.length && label && label.length && !this.hideActionButton) {
			this.$buyButtonLink.attr('href', link).text(label);
			this.$buyButton.removeClass('hidden');
		}
		else {
			this.$buyButton.addClass('hidden');
		}
	},

	/**
	 * Buy button event handler
	 * @param event
	 */
	handleBuyButton: function (event) {
		if ($(event.target).hasClass('disabled')) {
			event.stopImmediatePropagation();
			event.preventDefault();
		}
	},

	/**
	 * TODO: remove because not used
	 * 
	 * Select list event handler
	 * @param event
	 */
	handleContractChanged: function (event) {
		var value = $(event.target).val();
		if (value) {
			this.showUiState(STATE.multipleContractsWithSelection, this.getContractDateByNumber(value));
		}
		else {
			this.showUiState(STATE.multipleContractsNoSelection);
		}
	},

	/**
	 * TODO: remove because not used
	 * 
	 * Retrieve contract Data from phone number.
	 * @param number
	 * @returns {*}
	 */
	getContractDateByNumber: function (number) {
		var data;
		for (var i = 0, length = this.contractsWithRetention.length; i < length; i+=1) {
			if (this.contractsWithRetention[i].SubscriptionNumber === number) {
				data = this.contractsWithRetention[i];
				break;
			}
		}

		return data;
	},

	/**
	 * Returns the time string
	 */
	getTimeString: function (timeString) {
		return timeString.slice(6, -7);
	},

	/**
	 * Create the buy url, if there is a product ID.
	 *
	 * @param contract
	 * @returns {undefined}
	 */
	getBuyUrl: function (contract) {
		var url;
		if (this.productId && this.productId.length) {
			url = SCS.portal.addParamToUrl(this.data.urlCheckout, 'productId', this.productId);
			url = SCS.portal.addParamToUrl(url, 'refNo', contract.SubscriptionNumberMD5Hash);
		}

		return url;
	},

	/**
	 * Find the contract with the nearest contract end date from today.
	 */
	getContractWithNearestEndDate: function () {
		var nearestContract,
			nearestTimeString,
			contract,
			today = new Date().getTime(),
			timeString;

		for (var i = 0, length = this.contractsWithoutRetention.length; i < length; i+=1) {
			contract = this.contractsWithoutRetention[i];
			timeString = this.getTimeString(contract.ContractEndDate);

			if ((!nearestTimeString || timeString < nearestTimeString) && timeString > today) {
				nearestContract = contract;
				nearestTimeString = timeString;
			}
		}
		return nearestContract;
	},

	/**
	 * Display an error Message.
	 * @param errorThrown
	 * @param xhr
	 */
	showError: function (errorThrown, xhr) {
		if (typeof(xhr) !== 'undefined' && xhr.status === SCS.ecommerce.ECOMMERCE_SERVICE_UNAVAILABLE_EXCEPTION) {
			SCS.ecommerce.showEcommerceErrorMessage();
		} else {
			this.showUiState(STATE.error);
		}
	},

	/**
	 * Methods to subscribe and communicate with the Product Data hub
	 */
	onStartProductDataSubscription: function () {
		var mod = this,
			initialChannel = 'EcommerceProductDataHub';
		mod.sandbox.subscribe(initialChannel, mod);
		mod.fire('subscribeForProductData', {
			element: mod.$ctx,
			subscribe: function (channel) {
				mod.productDataChannel = channel;
				mod.sandbox.unsubscribe(initialChannel, mod);
				mod.sandbox.subscribe(channel, mod);
			}
		}, [initialChannel]);
	},

	/**
	 * Methods to subscribe and communicate with the Product Data hub
	 */
	onInvalidateProductData: function (data) {
		this.updateOnProductData(data.info);
	},

	updateOnProductData: function (data) {
		var mod = this;
		if (data && data.product) {
			var id = data.product.getId();
			mod.productId = id;
			var availability = data.product.getAvailability();
			availability.load().then(function() {
				if(id !== mod.productId) {
					mod.log.warn('product changed from', id, 'to', mod.productId);
					// User has changed the product since the availability info started loading
					return;
				}
				mod.log('got availability info for product', availability.isOrderable(), availability.getStatus());
				mod.$buyButtonLink.toggleClass('disabled', !availability.isOrderable());
			});
		}
		else {
			mod.productId = undefined;
		}
	}
});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.RetentionDisplay.js
// module id = 257
// module chunks = 0